import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EcrComponent } from '../ecr/ecr.component';
import { ECR } from '../models/ecr';
import { CrudService } from '../service/crud.service';
import { ECRService } from '../service/ecr.service';

@Component({
  selector: 'app-ecrstatus',
  templateUrl: './ecrstatus.component.html',
  styleUrls: ['./ecrstatus.component.css']
})
export class EcrstatusComponent implements OnInit, OnChanges {
  private _tmcId;
  @Input() filterMonth: number;
  @Input() filterYear: number;

  @Input()
  set tmcId(value: string) {
    if (value) {
      this._tmcId = value;
      this.applyFilters();
      this.EcRModel.TMCNo = value;
      this.getEmployeeDetails(this.tmcId);
      this.getReportingHeadDetails(this.tmcId);
      this.GetECRByTMCAndMonth();
    }
  }
  get tmcId(): string {
    return this._tmcId;
  }
  ECRList: ECR[] = [];
  EcRModel: ECR = new ECR();
  EmailList: any[] = [];
  ECrDocsList: any[] = [];
  URLDocs: any = "";
  TestURLDoc = "https://files.fm/down.php?i=sdymh2y6";
  ECRMonth: number = new Date().getMonth() + 1;
  ECRYear: number = new Date().getFullYear();
  yearOptions: number[] = [];
  searchQuery: string = '';
  selectedEcrId: any = null;
  viewMode: 'list' | 'calendar' = 'list';
  calendarEmployee: any = null;
  dateOfJoining: any = null;
  dateOfExit: any = null;
  previewHtml: SafeHtml = '';

  CompanyName: any = window.sessionStorage.getItem('CompanyName');
  constructor(
    private _ecrService: ECRService,
    public CrudSer: CrudService,
    private route: ActivatedRoute,
    private _router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.EcRModel = new ECR();
    this.EcRModel.TMCNo = sessionStorage.getItem('userId');
    this.EcRModel.EmployeeName = sessionStorage.getItem('FullName');
    this.EcRModel.FromEmail = sessionStorage.getItem('UserEmail');
    this.CompanyName = sessionStorage.getItem('CompanyName');
    this.EcRModel.ToEmail = window.sessionStorage.getItem('ReportingManagerEmail');
    this.buildYearOptions();
    console.log('this.EcRModel.ToEmail>>', this.EcRModel.ToEmail, this.EcRModel.TMCNo)
    console.log('sessionStorage.getItem("ReportingManagerEmail")>>', sessionStorage.getItem('userId'), sessionStorage.getItem('UserEmail'), sessionStorage.getItem('FullName'), sessionStorage.getItem('CompanyName'), sessionStorage.getItem('ReportingManagerEmail'), sessionStorage.getItem('ReportingManagerName'))
  }

  private buildYearOptions(): void {
    const current = new Date().getFullYear();
    this.yearOptions = [];
    for (let y = current; y >= current - 7; y--) {
      this.yearOptions.push(y);
    }
  }

  ngOnInit() {
    this.URLDocs = '';

    // HR drawer / embedded mode — employee comes from @Input(), not session
    if (this._tmcId) {
      this.applyFilters();
      return;
    }

    if (this.route.snapshot.queryParamMap.get('t')) {
      this.EcRModel.TMCNo = window.atob(this.route.snapshot.queryParamMap.get('t'));
      this.ECRMonth = parseInt(this.route.snapshot.queryParamMap.get('m'), 10);
    } else {
      this.EcRModel.TMCNo = sessionStorage.getItem('userId');
    }

    if ((this.EcRModel.TMCNo == '' || this.EcRModel.TMCNo == null || this.EcRModel.TMCNo == undefined) && this.tmcId === undefined) {
      alert('Invalid User');
      this._router.navigate(['/']);
      return;
    }

    this.GetECRByTMCAndMonth();
    this.getEmployeeDetails(this.EcRModel.TMCNo);
    this.getReportingHeadDetails(this.EcRModel.TMCNo);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.filterMonth || changes.filterYear) && this._tmcId) {
      this.applyFilters();
      this.GetECRByTMCAndMonth();
    }
  }

  private applyFilters(): void {
    if (this.filterMonth) {
      this.ECRMonth = this.filterMonth;
    }
    if (this.filterYear) {
      this.ECRYear = this.filterYear;
      if (this.yearOptions.indexOf(this.ECRYear) === -1) {
        this.yearOptions = [this.ECRYear, ...this.yearOptions].sort((a, b) => b - a);
      }
    }
  }

  /** True when hosted inside another page (e.g. HR drawer list tab). */
  get isEmbedded(): boolean {
    return !!this._tmcId;
  }

  setViewMode(mode: 'list' | 'calendar'): void {
    this.viewMode = mode;
    if (mode === 'calendar') {
      this.refreshCalendarEmployee();
    }
  }

  private refreshCalendarEmployee(): void {
    if (!this.EcRModel.TMCNo) {
      this.calendarEmployee = null;
      return;
    }
    this.calendarEmployee = {
      tmc_id: this.EcRModel.TMCNo,
      ecrMonth: this.ECRMonth,
      ecrYear: this.ECRYear,
      date_of_joining: this.dateOfJoining || new Date(this.ECRYear - 5, 0, 1),
      date_of_exit: this.dateOfExit || null
    };
  }
  GetECRDetails(item: any) {
    if (!item) {
      return;
    }
    this.selectedEcrId = item.ECRId;
    this.EmailList = this.parseCcEmails(item.OtherEmail);
    this.EcRModel.ECRId = item.ECRId;
    this.EcRModel.ECRSubject = item.ECRSubject;
    this.EcRModel.ECRDetails = item.ECRDetails;
    this.previewHtml = this.getSafeEcrHtml(item.ECRDetails);
    this.EcRModel.EcrDate = item.ECRDate;
    this.EcRModel.ECRStatus = item.ECRStatus;
    this.EcRModel.AppliedOn = item.AppliedOn;
    this.EcRModel.SubmittedDate = item.SubmittedDate;
    const tmcNo = item.TMCNo || item.TmcNo || this.EcRModel.TMCNo;
    const ecrDate = item.ECRDate || item.EcrDate || this.EcRModel.EcrDate;
    this.getECRDocs(tmcNo, ecrDate);
  }

  private formatEcrDateForApi(value: any): string {
    if (!value) {
      return '';
    }
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return String(value);
    }
    const year = parsed.getFullYear();
    const month = ('0' + (parsed.getMonth() + 1)).slice(-2);
    const day = ('0' + parsed.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }

  private normalizeEcrDocsList(raw: any): string[] {
    if (!raw) {
      return [];
    }
    const list = Array.isArray(raw) ? raw : [raw];
    return list
      .map((entry: any) => {
        if (typeof entry === 'string') {
          return entry;
        }
        return entry.FileName || entry.fileName || entry.name || '';
      })
      .filter((name: string) => !!name);
  }

  /** Build a safe download URL (encodes spaces/special chars in file names). */
  getAttachmentUrl(fileName: string): string {
    if (!fileName || !this.URLDocs) {
      return '#';
    }
    const name = String(fileName).trim();
    if (/^https?:\/\//i.test(name)) {
      return name;
    }
    const encodedName = name.split('/').map(part => encodeURIComponent(part)).join('/');
    return this.URLDocs + encodedName;
  }

  getECRDocs(TmcNo: string, EcrDate: string) {
    if (!TmcNo || !EcrDate) {
      this.ECrDocsList = [];
      return;
    }

    const formattedDate = this.formatEcrDateForApi(EcrDate);
    this.ECrDocsList = [];

    this._ecrService.GetECRDocsByTMC(TmcNo, formattedDate).subscribe(
      data => {
        const parsed = new Date(formattedDate);
        const date = parsed.getDate();
        const month = parsed.getMonth() + 1;
        const newmonth = month < 10 ? '0' + month.toString() : month.toString();
        const newDate = date < 10 ? '0' + date.toString() : date.toString();
        const year = parsed.getFullYear();
        this.URLDocs = this.CrudSer.DownLoadURL + TmcNo + '/' + newDate + '-' + newmonth + '-' + year + '/';
        this.ECrDocsList = data && data.Status !== false
          ? this.normalizeEcrDocsList(data.Data)
          : [];
      },
      error => {
        console.log(error);
        this.ECrDocsList = [];
      }
    );
  }

  /**
   * Keep editor formatting (bold, colors, tables, lists, inline styles) for preview.
   * Angular's default innerHTML sanitizer strips style attributes, so we sanitize
   * dangerous tags ourselves and then trust the remaining HTML.
   */
  getSafeEcrHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.sanitizePreviewHtml(html));
  }

  private sanitizePreviewHtml(value: string): string {
    if (!value) {
      return '';
    }

    let html = this.decodeStoredEcrHtml(String(value));

    try {
      const parser = new DOMParser();
      const documentFragment = parser.parseFromString(html, 'text/html');
      const allowedTags = /^(P|DIV|SPAN|STRONG|B|EM|I|U|S|SUP|SUB|BR|HR|UL|OL|LI|TABLE|THEAD|TBODY|TFOOT|TR|TD|TH|A|H1|H2|H3|H4|H5|H6|PRE|CODE|IMG|FONT)$/;
      const allowedAttributes = /^(class|style|title|align|colspan|rowspan|width|height|border|cellpadding|cellspacing|href|target|rel|src|alt|face|size|color)$/i;
      const safeCss = /^(color|background-color|font-family|font-size|font-weight|font-style|text-decoration|text-align|vertical-align|line-height|margin(?:-(?:top|right|bottom|left))?|padding(?:-(?:top|right|bottom|left))?|border(?:-(?:top|right|bottom|left)(?:-(?:width|style|color))?)?|border-collapse|white-space|width|height)\s*:/i;

      const clean = (element: Element): void => {
        Array.from(element.children).forEach(child => {
          const htmlChild = child as HTMLElement;
          if (!allowedTags.test(htmlChild.tagName)) {
            if (/^(SCRIPT|STYLE|IFRAME|OBJECT|EMBED|FORM|BASE|META|LINK)$/i.test(htmlChild.tagName)) {
              htmlChild.remove();
              return;
            }
            while (htmlChild.firstChild) {
              element.insertBefore(htmlChild.firstChild, htmlChild);
            }
            element.removeChild(htmlChild);
            return;
          }

          Array.from(htmlChild.attributes).forEach(attribute => {
            const name = attribute.name.toLowerCase();
            const attrValue = attribute.value.trim();
            if (!allowedAttributes.test(name) || name.indexOf('on') === 0) {
              htmlChild.removeAttribute(attribute.name);
            } else if (name === 'href' || name === 'src') {
              if (!/^(https?:|mailto:|\/|#)/i.test(attrValue) || /^javascript:/i.test(attrValue)) {
                htmlChild.removeAttribute(attribute.name);
              }
            } else if (name === 'style') {
              const styles = attrValue.split(';').filter(rule =>
                safeCss.test(rule) && !/(expression|url\s*\(|javascript)/i.test(rule)
              );
              if (styles.length) {
                htmlChild.setAttribute('style', styles.join(';'));
              } else {
                htmlChild.removeAttribute('style');
              }
            }
          });

          if (htmlChild.tagName === 'IMG' && !htmlChild.getAttribute('src')) {
            htmlChild.remove();
            return;
          }
          clean(htmlChild);
        });
      };

      Array.from(documentFragment.body.children).forEach(element => clean(element));
      return documentFragment.body.innerHTML;
    } catch {
      return html;
    }
  }

  private decodeStoredEcrHtml(html: string): string {
    if (!html) {
      return '';
    }
    const looksEscaped = html.indexOf('&lt;') !== -1
      && html.indexOf('<p') === -1
      && html.indexOf('<div') === -1
      && html.indexOf('<span') === -1
      && html.indexOf('<table') === -1;
    if (!looksEscaped) {
      return html;
    }
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  }

  parseCcEmails(raw: any): string[] {
    if (raw === null || raw === undefined || raw === '') {
      return [];
    }

    if (Array.isArray(raw)) {
      return raw
        .map((entry: any) => this.cleanEmailString(String(entry)))
        .filter((email: string) => this.isValidCcEmail(email));
    }

    let value = String(raw).trim();

    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed
          .map((entry: any) => this.cleanEmailString(String(entry)))
          .filter((email: string) => this.isValidCcEmail(email));
      }
      if (typeof parsed === 'string') {
        value = parsed;
      }
    } catch {
      // Not JSON — parse as comma-separated string
    }

    return value
      .split(',')
      .map((entry: string) => this.cleanEmailString(entry))
      .filter((email: string) => this.isValidCcEmail(email));
  }

  private cleanEmailString(email: string): string {
    return email
      .trim()
      .replace(/^["']+|["']+$/g, '')
      .replace(/\\"/g, '')
      .replace(/^"+|"+$/g, '')
      .trim();
  }

  private isValidCcEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    if (email === '"' || email === "'" || email === 'undefined') {
      return false;
    }
    return email.includes('@') && email.includes('.');
  }

  getFilteredEcrList(): ECR[] {
    let list = this.ECRList || [];
    if (this.searchQuery && this.searchQuery.trim()) {
      const q = this.searchQuery.trim().toLowerCase();
      list = list.filter(item => {
        const subject = (item.ECRSubject || '').toLowerCase();
        const rawDate = item.EcrDate || (item as any).ECRDate;
        const ecrDate = rawDate ? new Date(rawDate).toLocaleDateString().toLowerCase() : '';
        const applied = item.AppliedOn ? new Date(item.AppliedOn).toLocaleDateString().toLowerCase() : '';
        return subject.includes(q) || ecrDate.includes(q) || applied.includes(q);
      });
    }
    return [...list].sort((a, b) => {
      const dateA = new Date((a as any).ECRDate || a.EcrDate || 0).getTime();
      const dateB = new Date((b as any).ECRDate || b.EcrDate || 0).getTime();
      return dateB - dateA;
    });
  }

  getStatusLabel(status: string): string {
    if (!status) {
      return 'Submitted';
    }
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

  getStatusClass(status: string): string {
    const s = (status || 'SUBMITTED').toUpperCase();
    if (s.includes('PENDING') || s.includes('DRAFT')) {
      return s.includes('DRAFT') ? 'ecr-badge-draft' : 'ecr-badge-pending';
    }
    return 'ecr-badge-submitted';
  }

  getInitials(name: string): string {
    if (!name) {
      return 'EC';
    }
    return name.split(' ').filter(Boolean).slice(0, 2).map(n => n[0]).join('').toUpperCase();
  }

  printEcr(): void {
    window.print();
  }

  downloadPdf(): void {
    window.print();
  }

  forwardEcr(): void {
    const subject = encodeURIComponent(this.EcRModel.ECRSubject || 'ECR Report');
    const body = encodeURIComponent(
      `Please review the following ECR.\n\nEmployee: ${this.EcRModel.EmployeeName}\nDate: ${this.EcRModel.EcrDate}\n\nRegards`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }

  getEmployeeDetails(TmcNo: string) {
    this._ecrService.GetEmployeeInformation(TmcNo).subscribe(
      data => {

        this.EcRModel.FromEmail = data.Data.Company_E_Mail;
        this.EcRModel.EmployeeName = data.Data.Full_Name;
        this.dateOfJoining = data.Data.Date_of_Joining || data.Data.date_of_joining || null;
        this.dateOfExit = data.Data.Date_of_Exit || data.Data.date_of_exit || null;
        if (this.viewMode === 'calendar') {
          this.refreshCalendarEmployee();
        }
        console.log(data);

      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  getReportingHeadDetails(TmcNo: string) {
    this._ecrService.GetReportingHeadDetails(TmcNo).subscribe(
      data => {
        this.EcRModel.ToEmail = data.Data.Company_E_Mail;
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  GetECRByTMCAndMonth() {
    this._ecrService.GetECRByTMCAndMonthCalender(this.EcRModel.TMCNo, this.ECRMonth, this.ECRYear).subscribe(
      data => {
        if (data.Status) {
          this.ECRList = data.Data || [];
          const sortedList = this.getFilteredEcrList();
          if (sortedList.length > 0) {
            // Open the most recently submitted ECR (same order as left list)
            this.GetECRDetails(sortedList[0]);
          } else {
            this.selectedEcrId = null;
            this.EcRModel.ECRId = 0;
            this.previewHtml = '';
            this.ECrDocsList = [];
          }
          if (this.viewMode === 'calendar') {
            this.refreshCalendarEmployee();
          }
        }
        else {

        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }

  GetECRByTMC() {
    this._ecrService.GetECRByTMC(this.EcRModel.TMCNo).subscribe(
      data => {
        console.log(data);
        if (data.Status) {
          this.ECRList = data.Data;
        }
        else {

        }

      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }

}


